function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:url(#PurpleGradient);}.cls-2{fill:#fff;}"), React.createElement("linearGradient", {
  id: "PurpleGradient",
  x1: 31.22,
  y1: -154.4,
  x2: 181.22,
  y2: -154.4,
  gradientTransform: "translate(71.57 221.78) rotate(-45)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#4d27a8"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#a166ff"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Amazon-Route-53");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Reference"
}, React.createElement("rect", {
  id: "Purple_Gradient",
  "data-name": "Purple Gradient",
  className: "cls-1",
  width: 75,
  height: 75
}), React.createElement("g", {
  id: "Icon_Test",
  "data-name": "Icon Test"
}, React.createElement("path", {
  className: "cls-2",
  d: "M27.29,42.94a13,13,0,0,0,3.92.74A3.59,3.59,0,0,0,33.62,43a2.56,2.56,0,0,0,.83-2,2.62,2.62,0,0,0-.78-2.12,4,4,0,0,0-2.56-.66,30.05,30.05,0,0,0-3.2.2V37l.39-6.17h7.53V32.5H30l-.27,4.19a11.13,11.13,0,0,1,2-.2,4.93,4.93,0,0,1,3.49,1.17,4.23,4.23,0,0,1,1.25,3.24,4.07,4.07,0,0,1-1.46,3.27,5.76,5.76,0,0,1-3.86,1.25,9.53,9.53,0,0,1-3.94-.83Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M43.63,36.94l.21,0H44A4.62,4.62,0,0,1,47.28,38a3.83,3.83,0,0,1,1.2,3A4,4,0,0,1,47,44.21a6,6,0,0,1-3.91,1.21,9.51,9.51,0,0,1-3.83-.83V42.94a12.4,12.4,0,0,0,3.83.74,3.69,3.69,0,0,0,2.42-.7,2.44,2.44,0,0,0,.84-2q0-2.49-3.15-2.49a18.11,18.11,0,0,0-2,.1V37.23l4.33-4.73H39.48V30.81h8.4v1.63Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M37.5,56.5a1,1,0,0,1-.5-.14,33.17,33.17,0,0,0-10.48-4c-2.11-.38-9-2-9-7,0-2.26.87-3.76,2-5.66a15.66,15.66,0,0,0,2.71-8.21,14.58,14.58,0,0,0-2.38-7.93,1,1,0,0,1,.07-1.17l1.6-2a1,1,0,0,1,1.27-.24A13.69,13.69,0,0,0,29.54,22a12.33,12.33,0,0,0,7.38-2.32,1,1,0,0,1,1.16,0A12.33,12.33,0,0,0,45.46,22a13.69,13.69,0,0,0,6.77-1.86,1,1,0,0,1,1.27.24l1.6,2a1,1,0,0,1,.07,1.17,14.56,14.56,0,0,0-2.38,7.93c0,3.55,1.44,6,2.7,8.21,1.11,1.9,2,3.4,2,5.66,0,5-6.88,6.65-9,7a33.17,33.17,0,0,0-10.48,4A1,1,0,0,1,37.5,56.5ZM21.9,23a16.44,16.44,0,0,1,2.31,8.38c0,4.09-1.65,6.93-3,9.21-1,1.77-1.7,2.94-1.7,4.66,0,3.56,6.11,4.84,7.34,5.06a34.88,34.88,0,0,1,10.63,4,34.88,34.88,0,0,1,10.63-4c1.23-.22,7.34-1.5,7.34-5.06,0-1.72-.68-2.89-1.7-4.66-1.33-2.28-3-5.12-3-9.21A16.44,16.44,0,0,1,53.1,23l-.63-.78a15.44,15.44,0,0,1-7,1.72,14.43,14.43,0,0,1-8-2.3,14.43,14.43,0,0,1-8,2.3,15.44,15.44,0,0,1-7-1.72Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M37.5,62.5a1,1,0,0,1-.63-.22,30,30,0,0,0-11.25-5c-8.22-1.48-13.13-6-13.13-12a15.29,15.29,0,0,1,2.65-8.19c1.09-1.87,2-3.49,2-5.68a10.77,10.77,0,0,0-3.64-7.63,1,1,0,0,1-.14-1.48c0-.07,5.87-7.11,7.2-8.94a1,1,0,0,1,.78-.42,1,1,0,0,1,.82.32,10.34,10.34,0,0,0,7.35,3.66c2.79,0,5-1.24,7.13-4a1.08,1.08,0,0,1,1.66,0c2.14,2.8,4.34,4,7.13,4a10.34,10.34,0,0,0,7.35-3.66,1,1,0,0,1,.82-.32,1,1,0,0,1,.78.42c1.33,1.83,7.15,8.87,7.2,8.94a1,1,0,0,1,.24.77,1.09,1.09,0,0,1-.38.71,10.77,10.77,0,0,0-3.64,7.63c0,2.19.94,3.81,2,5.68a15.29,15.29,0,0,1,2.65,8.19c0,6-4.91,10.52-13.13,12a29.71,29.71,0,0,0-11.24,5A1,1,0,0,1,37.5,62.5ZM15.61,22.89a12.51,12.51,0,0,1,3.64,8.53c0,2.75-1.17,4.77-2.3,6.72-1.22,2.11-2.38,4.09-2.38,7.15,0,7.32,8.74,9.46,11.42,9.94A31.34,31.34,0,0,1,37.5,60.17,31.34,31.34,0,0,1,49,55.23c2.68-.48,11.42-2.62,11.42-9.94,0-3.06-1.16-5-2.38-7.15-1.13-2-2.3-4-2.3-6.72a12.51,12.51,0,0,1,3.64-8.53c-1.31-1.59-4.34-5.28-5.93-7.33a11.92,11.92,0,0,1-8,3.46,10.16,10.16,0,0,1-8-3.86,10.16,10.16,0,0,1-8,3.86,11.92,11.92,0,0,1-8-3.46C20,17.61,16.92,21.3,15.61,22.89Z"
})));

var SvgAwsRoute53 = function SvgAwsRoute53(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 75 75",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsRoute53, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-Route53.f43cdd37.svg";
export { ForwardRef as ReactComponent };